/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { OutletCtx, BreadcrumbItem, SidebarItem } from '@/containers';

export function usePageBreadcrumb(items: BreadcrumbItem[], resetOnUnmount = false) {
	const { setBreadcrumb } = useOutletContext<OutletCtx>();
	useEffect(() => {
		setBreadcrumb(items);
		return () => {
			if (resetOnUnmount) setBreadcrumb([]);
		};
	}, [JSON.stringify(items)]);
}

export function usePageSidebar(items: SidebarItem[], resetOnUnmount = false) {
	const { setSidebar } = useOutletContext<OutletCtx>();
	useEffect(() => {
		setSidebar(items);
		return () => {
			if (resetOnUnmount) setSidebar([]);
		};
	}, [JSON.stringify(items)]);
}
